/** Hover copy for the client-facing $/sf badge. */
export const PROJECT_COST_PER_SQFT_HOVER =
  'This value is calculated from total space enclosed or covered by timber framing, including additional floors, if applicable.';

/** Rounded project $/sf, or null when footage or total is missing/invalid. */
export function projectCostPerSqFt(total: number, sqft?: number | null): number | null {
  const footage = Number(sqft);
  const amount = Number(total);
  if (!Number.isFinite(footage) || footage <= 0 || !Number.isFinite(amount)) return null;
  return Math.round(amount / footage);
}
